"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HyperwalletPaymentStatus = void 0;
exports.HyperwalletPaymentStatus = {
    COMPLETED: "COMPLETED",
    IN_PROGRESS: "IN_PROGRESS",
    CANCELLED: "CANCELLED",
    FAILED: "FAILED",
    SCHEDULED: "SCHEDULED",
};
//# sourceMappingURL=HyperwalletPaymentStatus.js.map